import React, { PureComponent } from 'react';
import { reduxForm } from 'redux-form';
import { any, func, bool } from 'prop-types';
import Radium from 'radium';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';
import { UTButton, UTLabel, WithLoading, AlertHandler } from '@widergy/energy-ui';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import { ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { ACCOUNT_SELECTION } from 'constants/reduxForms';
import UTForm from 'app/components/UTForm';

import { accountRadioFields } from '../../constants';

import styles from './styles';

class AccountSelection extends PureComponent {
  state = {
    field: {}
  };

  componentDidMount() {
    if (isEmpty(this.props.accountsData)) {
      this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));
      AlertHandler.info(message('TerminationRequest:accountIsEmpty'));
    }
    this.createField();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.accountsData !== this.props.accountsData) this.createField();
  }

  createField = () => {
    if (!this.props.accountsData) {
      return this.setState({ field: {} });
    }
    return this.setState({ field: accountRadioFields(this.props.accountsData) });
  };

  render() {
    const { handleSubmit, submitFailed, invalid } = this.props;
    const fields = [
      {
        id: 1,
        key: 'clientNumber',
        selectedOptionsIds: this.state.field.field_options || [],
        ...this.state.field
      }
    ];
    return (
      <div style={styles.container}>
        <div style={styles.field}>
          <div style={styles.tittleContainer}>
            <UTLabel large extrabold style={styles.title}>
              {message('TerminationRequest:supplySelection')}
            </UTLabel>
          </div>
          <UTForm fields={fields} />
        </div>
        <UTButton disabled={submitFailed && invalid} onPress={handleSubmit} style={styles.button}>
          {message('AccountHolderChange:continue')}
        </UTButton>
      </div>
    );
  }
}

AccountSelection.propTypes = {
  accountsData: any, // eslint-disable-line
  handleSubmit: func.isRequired,
  submitFailed: bool,
  invalid: bool
};

const form = reduxForm({ form: ACCOUNT_SELECTION, onSubmitFail: errors => scrollToInvalid(errors) })(
  Radium(AccountSelection)
);
export default WithLoading(props => props.loading)(connect()(form));
